import React from 'react';
import { InputLabel } from '@mui/material';
import { find, isArray } from 'lodash';
import { FilterStyledFormControl } from './styles';
import Checkbox from '../../Checkbox/Checkbox';
import MenuItem from '../../MenuItem/MenuItem';
import Select from '../../Select/Select';

function FilterSelect(props) {
  const { label, shrink, options = [], showCheckboxes, ...rest } = props;
  const [selectedOptions, setSelectedOptions] = React.useState([]);

  const handleChange = (event) => {
    setSelectedOptions(event.target.value);
    props.onChange(event);
  };

  const handleClose = (event) => {
    if (props.onClose) {
      props.onClose(event);
    }
  };

  const normalizeValues = (selected) => {
    let labels = [];

    if (isArray(selected)) {
      labels = selected.filter((item) => item !== '').map((option) => find(options, { value: option }));
    } else {
      labels.push(find(options, { value: selected }));
    }

    return labels ? labels.map((item) => item.label).join(', ') : '';
  };

  return (
    <FilterStyledFormControl variant="standard" size="small">
      <InputLabel aria-setsize={12} shrink>
        {label}
      </InputLabel>
      <Select label={label} {...rest} onChange={handleChange} renderValue={normalizeValues} onClose={handleClose}>
        {options.map((option) => (
          <MenuItem key={option.value} value={option.value} title={option.label}>
            {showCheckboxes && <Checkbox checked={selectedOptions.indexOf(option.value) > -1} style={{ marginRight: 5 }} />}
            {option.label}
          </MenuItem>
        ))}
      </Select>
    </FilterStyledFormControl>
  );
}

export default FilterSelect;
